module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"new_item":"تسجيل منتج جديد","units_in_package":"و/ك"},"he":{"new_item":"מוצר חדש","units_in_package":"יח/כר"}}')
  delete Component.options._Ctor
}
